import { ReactNode } from "react";

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle: string;
  leftContent?: {
    title: string;
    subtitle: string;
    description: string;
    trustIndicator: string;
  };
}

export function AuthLayout({
  children,
  title,
  subtitle,
  leftContent = {
    title: "Smart Insights",
    subtitle: "& Analytics",
    description:
      "Monitor your AI-powered visual commerce tools with comprehensive analytics. Track performance, user engagement, and conversion metrics across all your features in one unified dashboard.",
    trustIndicator: "Real-time data insights",
  },
}: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen">
      {/* Left side - Brand Content */}
      <div className="hidden w-1/2 bg-white lg:flex lg:items-center lg:justify-center p-12">
        <div className="max-w-md text-center">
          <div className="mb-8 flex justify-center">
            <img src="/logo.webp" alt="Youzu Logo" className="h-20" />
          </div>
          <h1 className="mb-6 text-5xl font-bold leading-tight">
            <span className="bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
              {leftContent.title}
            </span>
            <br />
            <span className="text-gray-900">{leftContent.subtitle}</span>
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            {leftContent.description}
          </p>

          <p className="mt-4 text-sm text-green-600 flex items-center justify-center">
            <span className="mr-2">✓</span>
            {leftContent.trustIndicator}
          </p>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="flex w-full flex-col items-center justify-center bg-gray-100 px-4 py-12 lg:w-1/2">
        {/* Mobile Logo */}
        <div className="mb-8 flex flex-col items-center lg:hidden">
          <div className="mb-4">
            <img src="/logo.webp" alt="Youzu Logo" className="h-16" />
          </div>

        </div>

        <div className="w-full max-w-md space-y-8">
          {/* Form Header */}
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900">{title}</h2>
            <p className="mt-2 text-sm text-gray-600">{subtitle}</p>
          </div>

          {/* Form Container */}
          <div className="bg-white py-8 px-6 shadow-sm rounded-xl border border-gray-100">
            {children}
          </div>

          <div className="text-center">
            <p className="text-xs text-gray-500">
              &copy; {new Date().getFullYear()} Youzu. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
